import {Moment} from "moment";

export interface Commission {
    id: string
    commissionPlanId: string
    invoiceId: string
    referenceId: string
    referenceType: string
    productReferenceId: string
    productReferenceType: string
    salesAgentId: string
    commissionAmount: number
    commissionRate: number
    netCommissionableRevenue: number
    orderAmount: number
    name: string
    invoicePaidDate: Moment
    orderType: BillingOrderType
}

export enum BillingOrderType {
    Activation = 'Activation',
    Recurring = 'Recurring',
    RecurringIndefinitely = 'RecurringIndefinitely',
    OneTime = 'OneTime',
}